/** Formata dígitos digitados como centavos → string pt-BR (ex: "12345" → "123,45"). */
export function formatBRLFromDigits(digits: string): string {
  const cents = parseInt(digits.replace(/\D/g, ""), 10);
  const n = Number.isFinite(cents) && cents >= 0 ? cents : 0;
  return (n / 100).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Converte string já formatada em pt-BR para número (ex: "1.300,50" → 1300.5). */
export function parseBRLStringToNumber(formatted: string): number {
  if (!formatted || !String(formatted).trim()) return 0;
  const n = parseFloat(
    String(formatted).replace(/\./g, "").replace(",", ".")
  );
  return Number.isFinite(n) ? n : 0;
}

/** Converte número do banco (reais) para o formato exibido no input (centavos digitados). */
export function numberToBRLInputFormat(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(Number(value))) return "";
  const n = Number(value);
  return formatBRLFromDigits(String(Math.round(n * 100)));
}
